export default "__VITE_ASSET__B5Hpy9ec__"